import { render, staticRenderFns } from "./ModalSavedComments.vue?vue&type=template&id=1a0419db&scoped=true"
import script from "./ModalSavedComments.vue?vue&type=script&lang=js"
export * from "./ModalSavedComments.vue?vue&type=script&lang=js"
import style0 from "./ModalSavedComments.vue?vue&type=style&index=0&id=1a0419db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0419db",
  null
  
)

export default component.exports